import React, {CSSProperties} from "react"
import classNames from "classnames";

import styles from '../css/ButtonBar.module.css';

export interface Props {
    children?: React.ReactNode,
    style?: CSSProperties,
    right?: boolean,
}

export default (props: Props) => {
    const {children, style, right} = props;
    return (
        <div style={style} className={classNames(styles.buttonBarContainer, {
            [styles.buttonBarContainerRight]: right
        })}>
            <div className={classNames(styles.buttonBar, {
                [styles.buttonBarRight]: right
            })}>
                {children}
            </div>
        </div>
    )
}
